import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

import { faUsers, faTimes, faPlus, faUserNinja, faEllipsisV, faComments, faUserCheck, faUser, faUserTie, faHandshake } from '@fortawesome/free-solid-svg-icons'
import { AngelService } from '../services/angel.service';

import { ePartner } from '../services/entities'
import { GsapService } from '../services/gsap.service'
import { HaylieService } from '../services/haylie.service'

@Component({
  selector: 'app-page-partners',
  templateUrl: './page-partners.component.html',
  styleUrls: ['./page-partners.component.css']
})
export class PagePartnersComponent implements OnInit {
pageFAIcon = faHandshake;
FAIconPlus = faPlus;
FAIconClose = faTimes; 
FAIconActions = faEllipsisV;
FAIconNinja = faUserTie; 
FAIconWhats = faWhatsapp;
FAIconMsg = faComments;
player_live = false;
model_partners: ePartner[] = [];
model_partnersorg: ePartner[] = [];
page_frm = false;

@Input() activated: boolean = false;
  
  constructor(private angel: AngelService, 
    private gsap: GsapService, private haylie: HaylieService, private router: Router) 
  { 
    
  }
  ngOnChanges() {
    this.page_frm = false;
    
    if (this.activated) { this.content_refresh(); console.log('---changesrun.team'); }
  }
  content_refresh() {
    this.gsap.anima_trg('cronos', 'showup');
    this.page_frm = false;
    
    if (this.haylie.player_token(true, '').length > 0) {
      console.log('player> ' + this.haylie.player_token(true, ''));
      this.get_partners();

      this.player_live = true;
    }
    else {
      this.player_live = false; 

      this.gsap.magic_trg("#outsider_wrapper", "build");
      this.router.navigateByUrl('octalogin');
    }
  }
  ngOnInit(): void {
    
  }
  get_partners(): void {
    this.model_partners = [];
    this.model_partnersorg = [];

    this.haylie.get_partners("1").then(this.catch_partners);
  }
  /*compare( a: ePadawan, b: ePadawan) {
    if ( a._name < b._name ){
      return -1;
    }
    if ( a._name > b._name ){
      return 1;
    }
    return 0;
  }*/
  private catch_partners = (p_response: any): void =>  {
    var l_response = JSON.parse(p_response);
    console.log('catch.partners> ' + l_response.partners);

    if (l_response.partners.length > 0) {
      this.gsap.anima_trg('cronos', '');
      this.model_partners = l_response.partners;
      this.model_partnersorg = this.model_partners;
    } 
    
  }
  goBack():void {
    this.router.navigateByUrl("octahome");
  }
  goHaylie(p_action: string, p_target: string): void{
    console.log(p_action + ">" + p_target);

    /*switch(p_action) {
      case "profile":
        this.angel.profile_token(false, p_target);
        this.angel.player_compass(false, p_action);
        this.gsap.player_pages(p_action);
      break;

      case "gomsgs":
        console.log('gomsgs-loguser> ' + p_target); 
        this.angel.player_target(false, p_target);
        let buddy = this.model_padawansorg.filter(x => x.id == p_target); //duhflag
        this.angel.player_padawan(false, buddy[0]);   
        this.angel.player_compass(false, "msgs");
        this.gsap.player_pages("msgs");
      break;
    }*/

  }

  searchList(p_key:any):void {
    console.log('--- search key --- >>> ' + p_key);
    this.model_partners = [];
    if (p_key.target.value.length > 0)
      this.model_partners = this.model_partnersorg.filter(x => x.name.toLowerCase().indexOf(p_key.target.value.toLowerCase()) >= 0);
    else 
      this.model_partners = this.model_partnersorg;

  }

  switchFrm(p_action:string):void {
    if (p_action == 'on') { 
      // this.model_frm_id = 0; 
      // this.model_frm_skill = '';
      // this.model_frm_day = '';
      // this.model_frm_time = '';
    
      this.page_frm = true;
      this.gsap.magic_trg('#frmpartner', 'easybuild');
      this.gsap.magic_trg('#page_partner .fixed_action', 'vanish');
    }
    else { 
      this.gsap.magic_trg('#frmpartner', 'easyvanish');
      this.gsap.magic_trg('#page_partner .fixed_action', 'easybuild');
      this.page_frm = false;
    }



  }
  

}
